var map = {
	"./add-plan/add-plan.module": [
		"./src/app/admin/subscription-plan/add-plan/add-plan.module.ts",
		"common",
		"add-plan-add-plan-module"
	],
	"./admin-cms/admin-cms.module": [
		"./src/app/admin/admin-cms/admin-cms.module.ts",
		"common",
		"admin-cms-admin-cms-module"
	],
	"./admin-dashboard/admin-dashboard.module": [
		"./src/app/admin/admin-dashboard/admin-dashboard.module.ts",
		"default~admin-dashboard-admin-dashboard-module~doctor-dashboard-doctor-dashboard-module~hospital-das~a6a32a32",
		"common",
		"admin-dashboard-admin-dashboard-module"
	],
	"./admin-faq/admin-faq.module": [
		"./src/app/admin/admin-faq/admin-faq.module.ts",
		"admin-faq-admin-faq-module"
	],
	"./admin-specialties/admin-specialties.module": [
		"./src/app/admin/admin-specialties/admin-specialties.module.ts",
		"common",
		"admin-specialties-admin-specialties-module"
	],
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"default~admin-admin-module~doctor-doctor-module~doctor-edit-profile-doctor-edit-profile-module~front~d83f33c6",
		"default~admin-admin-module~doctor-doctor-module~hospital-hospital-module",
		"common",
		"admin-admin-module"
	],
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth-auth-module"
	],
	"./doctor-appointments/doctor-appointments.module": [
		"./src/app/frontend/doctor/doctor-appointments/doctor-appointments.module.ts",
		"common",
		"doctor-appointments-doctor-appointments-module"
	],
	"./doctor-dashboard/doctor-dashboard.module": [
		"./src/app/frontend/doctor/doctor-dashboard/doctor-dashboard.module.ts",
		"default~admin-dashboard-admin-dashboard-module~doctor-dashboard-doctor-dashboard-module~hospital-das~a6a32a32",
		"common",
		"doctor-dashboard-doctor-dashboard-module"
	],
	"./doctor-detail/doctor-detail.module": [
		"./src/app/admin/manage-doctors/doctor-detail/doctor-detail.module.ts",
		"common",
		"doctor-detail-doctor-detail-module"
	],
	"./doctor-edit-profile/doctor-edit-profile.module": [
		"./src/app/frontend/doctor/doctor-edit-profile/doctor-edit-profile.module.ts",
		"default~admin-admin-module~doctor-doctor-module~doctor-edit-profile-doctor-edit-profile-module~front~d83f33c6",
		"default~doctor-edit-profile-doctor-edit-profile-module~hospital-profile-hospital-profile-module~mana~81cba5e3",
		"common",
		"doctor-edit-profile-doctor-edit-profile-module"
	],
	"./doctor-profile/doctor-profile.module": [
		"./src/app/frontend/doctor/doctor-profile/doctor-profile.module.ts",
		"common",
		"doctor-profile-doctor-profile-module"
	],
	"./doctor-schedules/doctor-schedules.module": [
		"./src/app/frontend/doctor/doctor-schedules/doctor-schedules.module.ts",
		"default~doctor-schedules-doctor-schedules-module~hospital-detail-hospital-detail-module~hospital-doc~86c281ab",
		"common",
		"doctor-schedules-doctor-schedules-module"
	],
	"./doctor/doctor.module": [
		"./src/app/frontend/doctor/doctor.module.ts",
		"default~admin-admin-module~doctor-doctor-module~doctor-edit-profile-doctor-edit-profile-module~front~d83f33c6",
		"default~admin-admin-module~doctor-doctor-module~hospital-hospital-module",
		"common",
		"doctor-doctor-module"
	],
	"./edit-plan/edit-plan.module": [
		"./src/app/admin/subscription-plan/edit-plan/edit-plan.module.ts",
		"common",
		"edit-plan-edit-plan-module"
	],
	"./frontend/frontend.module": [
		"./src/app/frontend/frontend.module.ts",
		"default~admin-admin-module~doctor-doctor-module~doctor-edit-profile-doctor-edit-profile-module~front~d83f33c6",
		"common",
		"frontend-frontend-module"
	],
	"./hospital-appointments/hospital-appointments.module": [
		"./src/app/frontend/hospital/hospital-appointments/hospital-appointments.module.ts",
		"common",
		"hospital-appointments-hospital-appointments-module"
	],
	"./hospital-dashboard/hospital-dashboard.module": [
		"./src/app/frontend/hospital/hospital-dashboard/hospital-dashboard.module.ts",
		"default~admin-dashboard-admin-dashboard-module~doctor-dashboard-doctor-dashboard-module~hospital-das~a6a32a32",
		"common",
		"hospital-dashboard-hospital-dashboard-module"
	],
	"./hospital-detail/hospital-detail.module": [
		"./src/app/admin/manage-hospital/hospital-detail/hospital-detail.module.ts",
		"default~doctor-schedules-doctor-schedules-module~hospital-detail-hospital-detail-module~hospital-doc~86c281ab",
		"common",
		"hospital-detail-hospital-detail-module"
	],
	"./hospital-doctor-profile/hospital-doctor-profile.module": [
		"./src/app/frontend/hospital/hospital-doctors/hospital-doctor-profile/hospital-doctor-profile.module.ts",
		"default~doctor-schedules-doctor-schedules-module~hospital-detail-hospital-detail-module~hospital-doc~86c281ab",
		"default~admin-dashboard-admin-dashboard-module~doctor-dashboard-doctor-dashboard-module~hospital-das~a6a32a32",
		"common",
		"hospital-doctor-profile-hospital-doctor-profile-module"
	],
	"./hospital-doctor-shedules/hospital-doctor-shedules.module": [
		"./src/app/frontend/hospital/hospital-doctors/hospital-doctor-profile/hospital-doctor-shedules/hospital-doctor-shedules.module.ts",
		"default~doctor-schedules-doctor-schedules-module~hospital-detail-hospital-detail-module~hospital-doc~86c281ab",
		"common",
		"hospital-doctor-shedules-hospital-doctor-shedules-module"
	],
	"./hospital-doctors/hospital-doctors.module": [
		"./src/app/frontend/hospital/hospital-doctors/hospital-doctors.module.ts",
		"common",
		"hospital-doctors-hospital-doctors-module"
	],
	"./hospital-insurance/hospital-insurance.module": [
		"./src/app/frontend/hospital/hospital-insurance/hospital-insurance.module.ts",
		"common",
		"hospital-insurance-hospital-insurance-module"
	],
	"./hospital-profile/hospital-profile.module": [
		"./src/app/frontend/hospital/hospital-profile/hospital-profile.module.ts",
		"default~admin-admin-module~doctor-doctor-module~doctor-edit-profile-doctor-edit-profile-module~front~d83f33c6",
		"default~doctor-edit-profile-doctor-edit-profile-module~hospital-profile-hospital-profile-module~mana~81cba5e3",
		"common",
		"hospital-profile-hospital-profile-module"
	],
	"./hospital-settings/hospital-settings.module": [
		"./src/app/frontend/hospital/hospital-settings/hospital-settings.module.ts",
		"default~admin-admin-module~doctor-doctor-module~doctor-edit-profile-doctor-edit-profile-module~front~d83f33c6",
		"common",
		"hospital-settings-hospital-settings-module"
	],
	"./hospital/hospital.module": [
		"./src/app/frontend/hospital/hospital.module.ts",
		"default~admin-admin-module~doctor-doctor-module~doctor-edit-profile-doctor-edit-profile-module~front~d83f33c6",
		"default~admin-admin-module~doctor-doctor-module~hospital-hospital-module",
		"common",
		"hospital-hospital-module"
	],
	"./manage-doctors/manage-doctors.module": [
		"./src/app/admin/manage-doctors/manage-doctors.module.ts",
		"common",
		"manage-doctors-manage-doctors-module"
	],
	"./manage-hospital/manage-hospital.module": [
		"./src/app/admin/manage-hospital/manage-hospital.module.ts",
		"common",
		"manage-hospital-manage-hospital-module"
	],
	"./manage-insurance/manage-insurance.module": [
		"./src/app/admin/manage-insurance/manage-insurance.module.ts",
		"default~doctor-edit-profile-doctor-edit-profile-module~hospital-profile-hospital-profile-module~mana~81cba5e3",
		"common",
		"manage-insurance-manage-insurance-module"
	],
	"./manage-patients/manage-patients.module": [
		"./src/app/admin/manage-patients/manage-patients.module.ts",
		"common",
		"manage-patients-manage-patients-module"
	],
	"./patient-details/patient-details.module": [
		"./src/app/admin/manage-patients/patient-details/patient-details.module.ts",
		"common",
		"patient-details-patient-details-module"
	],
	"./subscription-plan/subscription-plan.module": [
		"./src/app/admin/subscription-plan/subscription-plan.module.ts",
		"default~doctor-schedules-doctor-schedules-module~hospital-detail-hospital-detail-module~hospital-doc~86c281ab",
		"common",
		"subscription-plan-subscription-plan-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;